import HeroBanner from "./components/HeroBanner";
import CategorySection from "./components/CategorySection";
import LatestSection from "./components/LatestSection";
import SchemaOrg from "@/components/feature/SchemaOrg";

export default function Home() {
  return (
    <>
      <SchemaOrg
        type="WebSite"
        data={{
          name: "51吃瓜",
          url: "https://51chigua.com",
          description:
            "51吃瓜网站聚焦每日大赛、台北娜娜、莫里秀、玩偶姐姐等热门系列，提供最新合集与高清视频资源",
          potentialAction: {
            "@type": "SearchAction",
            target: {
              "@type": "EntryPoint",
              urlTemplate: "https://51chigua.com/search?q={search_term_string}",
            },
            "query-input": "required name=search_term_string",
          },
        }}
      />
      <SchemaOrg
        type="WebPage"
        data={{
          name: "51吃瓜网站 - 首页",
          description:
            "51吃瓜网站✨特色栏目专区，聚焦每日大赛、台北娜娜、莫里秀、玩偶姐姐等热门系列，提供最新合集与高清视频资源",
          url: "https://51chigua.com",
          isPartOf: {
            "@type": "WebSite",
            name: "51吃瓜",
            url: "https://51chigua.com",
          },
          primaryImageOfPage: {
            "@type": "ImageObject",
            url: "https://readdy.ai/api/search-image?query=Dynamic%20entertainment%20media%20studio%20with%20vibrant%20neon%20accent%20lights%2C%20modern%20content%20creation%20atmosphere%2C%20dark%20background%20with%20colorful%20glowing%20elements%2C%20professional%20broadcast%20style&width=1600&height=900&seq=51chigua-hero&orientation=landscape",
          },
        }}
      />

      <main>
        <HeroBanner />
        <CategorySection />
        <LatestSection />
      </main>
    </>
  );
}